export function changeStreamUrl ({ obj, type, isShow }) {
  if (!type) {
    obj.playbackUrl = obj.mediaUrl.mediaUrl
  } else {
    obj[type] = obj.mediaUrl[type] || null
    if (isShow) {
      obj.mediaUrl.mediaUrl = obj.playbackUrl = angular.copy(obj.mediaUrl[type])
    }
  }
}

export function filterDRM (selected) {
  return function (item) {
    if (!selected?.length) {
      return true
    }
    const selectedProviderType = selected[0].providerType === item.providerType
    const selectedDrmType = selected.find(profile => profile.drmType === item.drmType)
    return selectedProviderType && !selectedDrmType
  }
}

export function getFilteredKeys (list = [], selected = [], property = 'id') {
  const checkProperty = (p) => ['string'].includes(typeof p) ? p : p[property]
  const selectedArr = selected.map(checkProperty)
  return (Array.isArray(list) ? list : Object.keys(list))
    .filter(key => !selectedArr?.includes(checkProperty(key)))
}

export function multiSelectWithAll (rules, model) {
  if (model.val === 'ALL' || model.val?.id === 'ALL') {
    rules.length = 0
  } else {
    rules.push(model.val)
    model.val = undefined
  }
}
